import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { getUrl } from "@outplayed/riot-assets";
import ReactSVG from "react-svg";
import { window } from "global";
import { ReactComponent as NewTag } from "svg/new-tag.svg";
import { ReactComponent as BetaTag } from "svg/beta-tag.svg";

const NavTab = (props) => {
  const location = useLocation();
  const [dropdown, setDropdown] = useState(false);
  const { tab, children, isLast } = props;

  useEffect(() => {
    dropdown && setDropdown(false);
  }, [location.pathname]);

  const buildDropdown = (dropdownItems) => {
    if (!Array.isArray(dropdownItems) || dropdownItems.length <= 0) {
      return null;
    }
    const search = location.search;
    let list = dropdownItems.map((item, index) => {
      const pathname = item.path;
      return item.customComponent ? (
        <div className="nav-dropdown-item" key={index} onClick={() => setDropdown(false)}>
          {item.customComponent}
        </div>
      ) : (
        <NavLink key={index} to={{ pathname, search }} className={`nav-dropdown-item`} onClick={() => setDropdown(false)}>
          {item.label}
          {item.new && <NewTag className="new-tag" />}
          {item.updated ? <img style={{ marginLeft: "10px" }} src="/UE4.svg" alt="UPDATED" /> : null}
        </NavLink>
      );
    });

    const dropDownClassNames = ["nav-dropdown", list.length === 0 ? "dropdown-empty" : ""].join(" ");

    return <div className={dropDownClassNames}>{list}</div>;
  };

  const isActive = () => {
    if (tab.dropdown) {
      return tab.dropdown.some((tab) => {
        return `${tab.path}` === location.pathname;
      });
    }

    if (tab.activePaths) {
      return tab.activePaths.some((path) => {
        const matches = location.pathname.match(path);
        return matches !== null;
      });
    }

    return false;
  };

  // if (tab.label === "Live Game" && !tab.liveIcon) tab.new = true;

  const search = tab.reset ? "" : tab.queryParams ? tab.queryParams : location.search;
  const pathname = tab.path;

  const tabProps = {
    className: classnames("nav-tab-link", { active: isActive(), "is-dropdown": tab.dropdown }),
    to: { pathname, search },
  };

  const TabComponent = ({ children }) =>
    tab.path ? <NavLink {...tabProps}>{children}</NavLink> : <div {...tabProps}>{children}</div>;

  const navTabClassNames = classnames("nav_tab", { last: isLast });
  return (
    <div
      className={navTabClassNames}
      onMouseEnter={() => tab.dropdown && setDropdown(true)}
      onMouseLeave={() => tab.dropdown && setDropdown(false)}
    >
      <TabComponent>
        {["inactive-label", "active-label"].map((label, index) => (
          <div key={index} className={`tab-label ${label}`}>
            {tab.customComponent || tab.label}
            {tab.new && <NewTag className="new-tag" />}
            {tab.updated && <img style={{ marginLeft: 5 }} src="/UE3.svg" alt="UPDATED" />}
            {tab.liveIcon && (
              <img
                style={{ marginLeft: 6 }}
                src="https://static.bigbrain.gg/assets/lol/icons/live-game-active.svg"
                alt="new-icon"
              />
            )}
          </div>
        ))}
      </TabComponent>
      {dropdown && buildDropdown(tab.dropdown)}
    </div>
  );
};

const PageNav = (props) => {
  const { tabs, className, queryParams } = props;

  return (
    <div className={`page-nav-container ${className}`}>
      <div className="nav_scroll-wrapper">
        <div className="nav_tabs-list">
          {tabs.map((tab, index) => {
            return (
              <div key={index} style={{ display: "flex", height: "100%" }}>
                <NavTab tab={tab} isLast={index == tabs.length - 1} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PageNav;
